import { FetchResult } from 'src/types/TApiQueries';
import { config } from 'src/utils/config';
import { getStandardHeaders, getUploadHeaders, performFetchWithLogging } from '../utils/helpers';

const baseUrl = (userId: number) => `${config.hostUrl}/api/v1/users/${userId}`;

export async function getAdminUserSettings(userId: number, accessToken: string): Promise<FetchResult<any>> {
  return performFetchWithLogging(`${baseUrl(userId)}/settings`, {
    method: 'GET',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}

type UpdateSettingsPayload = {
  key: string;
  value: { [key: string]: any };
};

export async function updateAdminUserSettings(
  userId: number,
  data: UpdateSettingsPayload,
  accessToken: string,
): Promise<FetchResult<any>> {
  return performFetchWithLogging(`${baseUrl(userId)}/settings`, {
    method: 'PATCH',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(data),
  });
}

export async function addAdminUserAddons(
  userId: number,
  data: Record<string, { enabled: boolean; added: boolean }>,
  accessToken: string,
): Promise<FetchResult<any>> {
  return performFetchWithLogging(`${baseUrl(userId)}/addons`, {
    method: 'POST',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(data),
  });
}

export async function removeAdminUserAddons(
  userId: number,
  addonKeys: string[],
  accessToken: string,
): Promise<FetchResult<any>> {
  return performFetchWithLogging(`${baseUrl(userId)}/addons`, {
    method: 'DELETE',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(addonKeys),
  });
}

export async function updateAdminUserAddonSettings(
  userId: number,
  addonKey: string,
  data: any,
  accessToken: string,
): Promise<FetchResult<any>> {
  return performFetchWithLogging(`${baseUrl(userId)}/settings/addons/${addonKey}`, {
    method: 'POST',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(data),
  });
}

export async function uploadAdminUserWatermark(
  userId: number,
  file: File,
  accessToken: string,
): Promise<FetchResult<any>> {
  const form = new FormData();
  form.append('file', file);

  return performFetchWithLogging(`${baseUrl(userId)}/settings/watermark`, {
    method: 'POST',
    headers: getUploadHeaders(accessToken),
    credentials: 'include',
    body: form,
  });
}
